import React from 'react';
import Actions from './Actions';
import CapabilityQuestionBank from './CapabilityQuestionBank';
import AnswerSetTool from './AnswerSetTool';

function Tools() {
  return (
    <>
      <Actions />
      <CapabilityQuestionBank />
      <AnswerSetTool />
    </>
  );
}

export default Tools;
